import { Dispatch } from "redux";
import { ActionType } from "../actions/ActionTypes";
import axios from "axios";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const GetUserProfile = (uid: string) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ActionType.GET_USER_PROFILE_INIT });
      const url = `${BASE_URL}/user/${encodeURIComponent(uid)}`;
      const response = await axios.get(url);

      dispatch({
        type: ActionType.GET_USER_PROFILE_SUCCESS,
        payload: response.data,
      });
    } catch (error: any) {
      toast.error("Session expired. Please log in again.");
      localStorage.removeItem("uid");
      localStorage.removeItem("method");
      dispatch({
        type: ActionType.GET_USER_PROFILE_FAIL,
        payload: "An unexpected error occurred",
      });
    }
  };
};


export const UpdateUserProfile = (uid: string, updatedUser: any, type?: string) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ActionType.UPDATE_USER_PROFILE_INIT });
      const url = `${BASE_URL}/user/update/${encodeURIComponent(uid)}`;
      
      const response = await axios.patch(url, updatedUser);

      if(type==='setting'){
        toast.success("Setting saved!");
      }else{
        toast.success("Profile updated successfully!");
      }
      dispatch({
        type: ActionType.UPDATE_USER_PROFILE_SUCCESS,
        payload: response.data.user,
      });
    } catch (error: any) {
      toast.error("An unexpected error occurred");
      dispatch({
        type: ActionType.UPDATE_USER_PROFILE_FAIL,
        payload: "An unexpected error occurred",
      });
    }
  };
};

export const PlanUpgradeRemindMeLater = (uid: string) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      const payload = {
        userId: uid,
      };
      const url = `${BASE_URL}/user/plan-upgrade/remind-me-later`;
      const response = await axios.post(url, payload);
      if (uid) {
        dispatch(GetUserProfile(uid));
      }
    } catch (error: any) {}
  };
};